/*Tps-report*/
if (window.location.pathname.includes("reports/lead")) {
    $.each($('.data-table'), function() {
        $(this).data('options', window.app.datatableOptions.default);
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/reports/lead.js